import React from "react";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { formatDateReadable } from "../../utilities/helpers";
import { Drawer } from "@mui/material";
import DrawerHeader from "../../shared/helpers/DrawerHeader";
import ButtonFilled from "../../shared/helpers/ButtonFilled";
import ButtonFilledCancel from "../../shared/helpers/ButtonFilledCancel";
import DrawerFooterContainerSmall from "../../shared/helpers/DrawerFooterContainerSmall";
import { getCardColor2 } from "../../../../../helpers/helpers";
import StatusWithText from "../../shared/helpers/StatusWithText";

export default function TradesRequestsTableRow(props) {
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  function handleDeny() {
    props.manager_reject_shift_drop(props.senderShiftId);
    setDrawerOpen(false);
  }

  function handleApprove() {
    props.manager_approve_shift_pickup(props.pickupUUID, "approved");
    setDrawerOpen(false);
  }

  return (
    <>
      <tr
        className="hover:bg-slate-50 cursor-pointer transition-colors"
        onClick={toggleDrawer(true)}
      >
        <td className="py-3.5 pl-6 pr-3 text-sm">
          <div className="flex items-center rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
            <div className="flex-1">
              <p className="text-sm font-semibold text-slate-900">
                {props.senderName}
              </p>
              <p className="text-xs text-slate-400 mt-0.5">is trading away</p>
              <div className="flex mt-2">
                <div className={`w-1 rounded-full mr-2 ${getCardColor2(props.senderTrade?.role_id?.id, props.roleNames, false)}`}></div>
                <div>
                  <p className="text-xs font-semibold text-slate-900">{props.senderShift}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{props.senderStation ? props.senderStation?.name : props.senderRole ? props.senderRole : props.senderRoleType}</p>
                  <p className="text-xs text-slate-400 mt-0.5">{formatDateReadable(props.senderDate)}</p>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td className="px-3 py-3.5 text-sm">
          <div className="w-full flex justify-center">
            <div className="w-8 h-8 bg-violet-50 border border-violet-200 flex items-center justify-center rounded-full">
              <SwapHorizIcon sx={{ fontSize: 16, color: "#7c3aed" }} />
            </div>
          </div>
        </td>
        <td className="pr-6 py-3.5 text-sm">
          <div className="flex items-center rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
            <div className="flex-1">
              <p className="text-sm font-semibold text-slate-900 text-right">
                {props.receiverName}
              </p>
              <p className="text-xs text-slate-400 mt-0.5 text-right">is trading away</p>
              <div className="flex flex-row-reverse mt-2">
                <div className={`w-1 rounded-full ml-2 ${getCardColor2(props.receiverTrade?.role_id?.id, props.roleNames, false)}`}></div>
                <div>
                  <p className="text-xs font-semibold text-slate-900 text-right">{props.receiverShift}</p>
                  <p className="text-xs text-slate-500 mt-0.5 text-right">{props.receiverStation ? props.receiverStation?.name : props.receiverRole ? props.receiverRole : props.receiverRoleType}</p>
                  <p className="text-xs text-slate-400 mt-0.5 text-right">{formatDateReadable(props.receiverDate)}</p>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td className="relative py-3.5 pl-3 pr-6">
        </td>
      </tr>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div className="w-[450px] h-full bg-white relative">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader title="Trade Request" onClose={toggleDrawer(false)} />
            <div className="px-6 mt-6">
              <div className="w-full flex flex-row items-stretch relative">
                <div className="w-1/2 pr-3">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Sender</p>
                  <div className="rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
                    <p className="text-sm font-semibold text-slate-900">{props.senderName}</p>
                    <p className="text-xs text-slate-400 mt-0.5">is trading away</p>
                    <div className="flex mt-2">
                      <div className={`w-1 rounded-full mr-2 ${getCardColor2(props.senderTrade?.role_id?.id, props.roleNames, false)}`}></div>
                      <div>
                        <p className="text-xs font-semibold text-slate-900">{props.senderShift}</p>
                        <p className="text-xs text-slate-500 mt-0.5">
                          {props.senderStation ? props.senderStation : props.senderRole ? props.senderRole : props.senderRoleType}
                        </p>
                        <p className="text-xs text-slate-400 mt-0.5">{formatDateReadable(props.senderDate)}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute z-30 left-1/2 top-1/2 -ml-4 mt-1">
                  <div className="w-8 h-8 bg-violet-50 border border-violet-200 flex items-center justify-center rounded-full">
                    <SwapHorizIcon sx={{ fontSize: 16, color: "#7c3aed" }} />
                  </div>
                </div>
                <div className="w-1/2 pl-3">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2 text-right">Receiver</p>
                  <div className="rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
                    <p className="text-sm font-semibold text-slate-900 text-right">{props.receiverName}</p>
                    <p className="text-xs text-slate-400 mt-0.5 text-right">is trading away</p>
                    <div className="flex flex-row-reverse mt-2">
                      <div className={`w-1 rounded-full ml-2 ${getCardColor2(props.receiverTrade?.role_id?.id, props.roleNames, false)}`}></div>
                      <div>
                        <p className="text-xs font-semibold text-slate-900 text-right">{props.receiverShift}</p>
                        <p className="text-xs text-slate-500 mt-0.5 text-right">
                          {props.receiverStation ? props.receiverStation : props.receiverRole ? props.receiverRole : props.receiverRoleType}
                        </p>
                        <p className="text-xs text-slate-400 mt-0.5 text-right">{formatDateReadable(props.receiverDate)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Status</p>
                <StatusWithText status="pending" />
              </div>
            </div>
            <div className="h-[200px]"></div>
            <DrawerFooterContainerSmall>
              <div className="w-full flex flex-row items-center">
                <div className="w-1/2 pr-2">
                  <ButtonFilledCancel text="Deny" onClick={() => handleDeny()} />
                </div>
                <div className="w-1/2 pl-2">
                  <ButtonFilled text="Approve" onClick={() => handleApprove()} />
                </div>
              </div>
            </DrawerFooterContainerSmall>
            </div>
        </div>
      </Drawer>
    </>
  );
}
